<template>
  <div style="height: 100%;">
    <div class="message-wrapper">
      <div class="message-inner">
        <div class="content">
          <div class="title">尊敬的用户，您好:</div>
          <div class="text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;系统检测到您的电脑上已安装的<span
              class="redLetter"
              >{{ total }}</span
            >款软件，可能存在侵权风险，如有疑问请邮件联系banquan-support@58.com。
          </div>
        </div>
        <div class="table mt20">
          <el-table size="small" :data="softList">
            <el-table-column prop="" label="序号" type="index">
            </el-table-column>
            <el-table-column prop="soft_name" label="软件名称">
            </el-table-column>
            <el-table-column prop="soft_version" label="软件版本">
            </el-table-column>
            <el-table-column prop="install_date" label="安装时间">
            </el-table-column>
            <el-table-column prop="machine_name" label="设备型号">
            </el-table-column>
            <el-table-column prop="platform" label="操作系统">
              <template slot-scope="scope">
                <template v-if="scope.row.platform == 1">
                  <span>Mac</span>
                </template>
                <template v-if="scope.row.platform == 2">
                  <span>Windows</span>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="content mt20">
          <div class="title">建议处理方式:</div>
          <div class="text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;卸载上述软件，如确有办公使用需求，请提交&nbsp;<a
              href="https://bpmops.58corp.com/process/index#/formrender?origin=apply&processKey=ViifzsNfCw&businessGroupId=2"
              class="alink"
              >软件使用申请</a
            >。
          </div>
        </div>
        <div class="content mt20" style="padding-bottom:20px;">
          <div class="title red">温馨提示:</div>
          <div class="text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;若安装的软件因侵权所带来的损失将由使用人所在部门承担。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appVersionListService from "../api/service/appVersionListService";
export default {
  name: "MessageView",
  components: {},
  props: {},
  data: () => ({
    total: 0,
    softList: [],
  }),
  methods: {
    showSoftList: async function () {
      let res = await appVersionListService.getSoftList();
      const result = JSON.parse(res.data);
      if (result.code == 0) {
        this.total = result.data.total;
        this.softList = result.data.soft_list;
      } else {
        this.$message.error(result.message);
      }
    },
  },
  mounted() {
    this.showSoftList();
  },
};
</script>
<style scoped>
.message-wrapper {
  height: 100%;
  padding: 20px 0;
  box-sizing: border-box;
}
.message-inner {
  height: 100%;
  width: 90%;
  margin: 0 auto;
}
.message-inner .table {
  width: 100%;
  font-size: 12px;
}
.message-inner .content {
}
.message-inner .content .title {
  font-weight: bold;
  font-size: 14px;
  line-height: 28px;
}
.message-inner .content .text {
  margin-top: 5px;
  font-size: 14px;
  line-height: 28px;
}
.redLetter {
  color: #f00;
  font-weight: bold;
  padding: 0 5px;
  font-size: 18px;
  line-height: 30px;
}
.mt20 {
  margin-top: 20px;
}
.red {
  color: #f00;
}
.alink {
  color: #1337d0;
}
.alink:hover {
  color: #748cf6;
  text-decoration: underline;
}
</style>
